
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 34 30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.302 6.68L.049 22.773l-.038.151a.834.834 0 00.001.275.892.892 0 00.2.423c.102.122.237.222.399.29.09.038.19.065.294.078l.172.01H32.94c.583 0 1.111-.425 1.056-.944a1.548 1.548 0 00-.123-.494L28.665 6.698a.9.9 0 00-.061-.153.969.969 0 00-.325-.356 1.111 1.111 0 00-.473-.178 1.197 1.197 0 00-.18-.01H6.334a1.158 1.158 0 00-.292.032c-.241.057-.455.191-.597.375a.916.916 0 00-.144.272zM24.11 7.888l1.043 5.63h-3.389l.707-.679a.875.875 0 00-.054-1.333 1.147 1.147 0 00-1.493.048l-2.35 2.26-.125.145-.091.167-.054.182-.011.184.028.185.068.172.102.158.136.137 2.702 2.258a1.147 1.147 0 001.493-.045c.398-.38.375-.978-.05-1.335l-.738-.615h3.47l1.242 6.705h4.749L26.853 7.888H24.11z","fill":"currentColor"}})])
          )
        }
      }
    